/** Where the app's own static files are served from.
 *
 *  The production build is served at the site root (Vite `base` '/'), so
 *  these give the same `/brand/…` addresses as before. The demonstration
 *  build uses base './' so the compiled preview also runs from a sub-path
 *  (a folder on a file server, or a published artifact); a root-absolute
 *  `/brand/…` there points at the host's root and loads nothing. */

/** A path for the document to resolve, e.g. an <img src>. */
export function assetPath(path: string): string {
  return `${import.meta.env.BASE_URL}${path.replace(/^\/+/, '')}`
}

/** An absolute URL, for consumers that do not resolve relative addresses
 *  against the page: MapLibre's glyph, sprite and source URLs, and its
 *  worker. Keeps the answer free of a trailing slash so callers can append
 *  `/basemap/…` as they did with `window.location.origin`. */
export function assetBase(): string {
  return new URL(import.meta.env.BASE_URL, window.location.href).href.replace(/\/+$/, '')
}
